import { useState, useEffect } from 'react';
import SubEditor from './subMainEditor';
import { ImagePlus } from 'lucide-react';
import { useHistory } from "react-router-dom";
import {  useGetCategoryQuery, useGetAuthorQuery, useGetPostQuery, useEditPostMutation } from '../../reactWrapper/Redux/apiSlice';

const EditPage =({ postId }) => {

    const { data: post } = useGetPostQuery(postId)
    console.log('the post here', post)
    const [editPost, { isLoading: isPosting }] = useEditPostMutation()

    const { data: category,  isError: errCat, error: errCatMsg } = useGetCategoryQuery();
    console.log('category data', category);
    const { data: authors, isLoading: loadingAut, isError: errAut, error: errAutMsg } = useGetAuthorQuery();
    console.log('category data', authors);

    const history = useHistory();

    const [title, setTitle] = useState([post[0].title]);
    const [category_id, setCategory_Id] = useState([post[0].category_id]);
    // const [content, setContent] = useState([post[0].content]);
    const [featured_image_link, setFeatured_Image_Link] = useState([post[0].featured_image_link]);
    const [featured_image_links, setFeatured_Image_Links] = useState([post[0].featured_image_link]);
    const [authors_name, setAuthors_Name] = useState([post[0].authors_name]);
    const [meta_description, setMeta_Description] = useState([post[0].meta_description]);
    const [key_phrase, setKey_Phrase] = useState([post[0].key_phrase]);

    useEffect(() => {
        console.log('data', category)
    }, [category])

    useEffect(() => {
        console.log('data', authors)
    }, [authors])

    const handleSubmit = async (e) => {
        e.preventDefault();
        var formdata = new FormData();

        formdata.append("id", postId);
        formdata.append("title", title);
        formdata.append("authors_name", authors_name);
        formdata.append("featured_image_link", featured_image_link);
        formdata.append("category_id", category_id);
        formdata.append("meta_description", meta_description);
        formdata.append("key_phrase", key_phrase);
//FORTUNE'S contribution: await editPost({ID: postId, form: formdata})
        await editPost(formdata)
        history.push(`/mypost/${postId}`)
    };

    const handleChange = (event) => {
        // if (event.target.files && event.target.files[0]) {
        setFeatured_Image_Links(URL.createObjectURL(event.target.files[0]));
        // console.log('this is the full image', featured_image_link)
        setFeatured_Image_Link(event.target.files[0])
        console.log('this is the full image', featured_image_link)
        // }
    };

    return (
        <form
            onSubmit={handleSubmit}
            className='rounded-2xl border bg-card p-6 shadow-ui-sm'
        >
            <div className='grid grid-cols-1 gap-4 sm:grid-cols-2'>
                {/* BLOG IMAGE */}
                <div className='sm:col-span-2'>
                    <span className='text-sm font-medium leading-none text-brand-navy'>
                        Blog Image
                    </span>
                    <label
                        htmlFor='featured_image'
                        className='mt-1 flex cursor-pointer flex-col items-center justify-center rounded-xl border-2 border-dashed border-brand-navy/20 bg-surface py-12 transition-colors hover:border-brand-orange hover:bg-brand-orange-100/30'
                    >
                        <ImagePlus className='h-6 w-6 text-brand-navy' />
                        <span className='mt-2 text-sm font-medium text-brand-navy'>
                            Replace image
                        </span>
                        <span className='mt-0.5 text-xs text-muted-foreground'>
                            PNG or JPG
                        </span>
                        <input
                            id='featured_image'
                            type='file'
                            className='sr-only'
                            onChange={(e) => handleChange(e)}
                        />
                    </label>

                    {featured_image_links && (
                        <div className='mt-3 h-60 overflow-hidden rounded-xl border'>
                            <img
                                src={featured_image_links}
                                alt='preview view'
                                className='h-full w-full object-cover'
                            />
                        </div>
                    )}
                </div>

                {/* TITLE */}
                <div className='sm:col-span-2'>
                    <label
                        htmlFor='title'
                        className='text-sm font-medium leading-none text-brand-navy'
                    >
                        Title
                    </label>
                    <input
                        type='text'
                        className='mt-1 flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-ui-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring'
                        name='title'
                        id='title'
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        required
                    />
                </div>

                {/* KEY PHRASES */}
                <div className='sm:col-span-2'>
                    <label
                        htmlFor='key_phrase'
                        className='text-sm font-medium leading-none text-brand-navy'
                    >
                        Key Phrases
                    </label>
                    <input
                        type='text'
                        className='mt-1 flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-ui-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring'
                        name='key_phrase'
                        id='key_phrase'
                        value={key_phrase}
                        onChange={(e) => setKey_Phrase(e.target.value)}
                        required
                    />
                </div>

                {/* CATEGORY */}
                <div>
                    <label
                        htmlFor='category'
                        className='text-sm font-medium leading-none text-brand-navy'
                    >
                        Choose Category
                    </label>
                    <select
                        id='category'
                        value={category_id}
                        onChange={(e) => setCategory_Id(e.target.value)}
                        className='mt-1 flex h-9 w-full rounded-md border border-input bg-transparent px-3 text-sm shadow-ui-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring'
                        name='action'
                    >
                        {category && category.map((item) => (
                            <option key={item.id} value={item.id}>
                                {item.name}
                            </option>
                        ))}
                    </select>
                    {/* the error block used to render INSIDE the <select>, which is invalid */}
                    {errCat && (
                        <div className='mt-2 flex items-start gap-2 rounded-lg bg-red-50 p-3 text-xs text-red-800'>
                            {errCatMsg.toString()}
                        </div>
                    )}
                </div>

                {/* AUTHOR */}
                <div>
                    <label
                        htmlFor='author'
                        className='text-sm font-medium leading-none text-brand-navy'
                    >
                        Select Author
                    </label>
                    <select
                        id='author'
                        value={authors_name}
                        onChange={(e) => setAuthors_Name(e.target.value)}
                        className='mt-1 flex h-9 w-full rounded-md border border-input bg-transparent px-3 text-sm shadow-ui-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring'
                        name='action'
                    >
                        {loadingAut && <option>Loading...</option>}
                        {authors && authors.map((item) => (
                            <option key={item.id}>
                                {item.name}
                            </option>
                        ))}
                    </select>
                    {errAut && (
                        <div className='mt-2 flex items-start gap-2 rounded-lg bg-red-50 p-3 text-xs text-red-800'>
                            {errAutMsg.toString()}
                        </div>
                    )}
                </div>

                {/* META DESCRIPTION */}
                <div className='sm:col-span-2'>
                    <label
                        htmlFor='meta'
                        className='text-sm font-medium leading-none text-brand-navy'
                    >
                        Meta Description
                    </label>
                    <textarea
                        name='content'
                        id='meta'
                        rows={4}
                        className='mt-1 flex w-full resize-none rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-ui-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring'
                        value={meta_description}
                        onChange={(e) => setMeta_Description(e.target.value)}
                        required
                    />
                </div>

                {/* <SubEditor content={content} setContent={setContent} /> */}
            </div>

            {/* FOOTER: helper control left, the one orange commit right */}
            <div className='mt-6 flex flex-col-reverse gap-3 border-t pt-4 sm:flex-row sm:items-center sm:justify-between'>
                <select
                    className='h-9 rounded-md border border-input bg-transparent px-3 text-sm shadow-ui-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring sm:w-52'
                    name='action'
                >
                    <option>Save and Publish</option>
                    <option>Save Draft</option>
                </select>

                <button
                    type='submit'
                    disabled={isPosting}
                    className='inline-flex h-9 items-center justify-center rounded-lg bg-brand-orange px-4 text-sm font-semibold text-white transition-colors hover:bg-brand-orange-600 disabled:pointer-events-none disabled:opacity-50'
                >
                    {isPosting ? 'Updating...' : 'Update'}
                </button>
            </div>
        </form>
    )
}

export default EditPage;
